module.exports = __webpack_public_path__ + "static/mens-health-863becaa1601868bb5e47d812315bb41.svg";